<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <b-card class="bCardGlobal">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Quejas</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>C-**</div>
        </b-col>
      </b-row>

      <div class="divSubtitulo">
        <p class="textSubtitulo">Dictamen operativo</p>
      </div>

      <div class="container-fluid main-component">
        <div class="row justify-content-center">
          <div class="col-sm-12 col-md-8 col-lg-5 col-xl-5">
            <b-card
              style="
                padding: 1%;
                width: 100%;
                border-radius: 20px;
                box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
              "
            >
              <p
                style="
                  text-align: left;
                  color: #093974;
                  font-size: 18px;
                  font-weight: 600;
                "
              >
                Información de la queja
              </p>
              <b-table-simple style="margin-top: 7%; text-align: left">
                <tr>
                  <td style="font-size: 15px"><label>ID Paciente</label></td>
                  <td style="font-size: 15px">{{ datos.idPaciente }}</td>
                </tr>
                <tr>
                  <td style="font-size: 15px">
                    <label>Nombre del Paciente</label>
                  </td>
                  <td style="font-size: 15px">{{ datos.paciente }}</td>
                </tr>
                <tr>
                  <td style="font-size: 15px">
                    <label
                      >Tipo de paciente (Nat o Plan) / Para reforzar aviso a
                      comercial</label
                    >
                  </td>
                  <td style="font-size: 15px">
                    {{ datosAdicionales.tipoPaciente }}
                  </td>
                </tr>
                <tr>
                  <td style="font-size: 15px">
                    <label>Monto Total del PTI</label>
                  </td>
                  <td style="font-size: 15px">
                    {{ datosAdicionales.montoPti | monedaEntero }}
                  </td>
                </tr>
              </b-table-simple>
              <div style="margin-top: 10%">
                <p>
                  A través de <strong>{{ datos.origen }}</strong> el paciente
                  comenta:
                </p>
                <p v-if="datos.comentarios.length < 160">
                  <strong>{{ datos.comentarios }}</strong>
                </p>
                <b-button variant="info" v-else @click="modalComentarios = true"
                  >Ver comentarios</b-button
                >
              </div>
            </b-card>
          </div>
          <!-- pao col -->
          <div class="col-sm-12 col-md-12 col-lg-7 col-xl-7">
            <div class="container-fluid main-component" style="margin-top: 3%">
              <div class="row justify-content-between">
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <p
                    style="
                      text-align: left;
                      color: #093974;
                      font-size: 18px;
                      font-weight: 600;
                    "
                  >
                    Tratamientos realizados
                  </p>
                  <div v-if="sesiones.length > 0">
                    <vue-custom-scrollbar
                      class="scroll-area"
                      :settings="settings"
                      @ps-scroll-y="scrollHanle"
                    >
                      <div
                        v-for="item in sesiones"
                        :key="'tx' + item.idTratamientoProgramado"
                      >
                        <b-card
                          style="
                            padding: 2%;
                            box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
                          "
                          v-if="item.tratamiento != 'Sin Dato'"
                        >
                          <div class="row">
                            <div class="col-3">
                              <img
                                width="100%"
                                style="max-width: 100%"
                                src="../../../assets/icons/tratamiento.png"
                              />
                            </div>
                            <div class="col-9" style="text-align: left">
                              <p style="margin: 4%">
                                <label>Tx:</label>{{ item.tratamiento }}
                              </p>
                              <p style="margin: 4%">
                                <label>Num. sesión:</label
                                >{{ item.numeroSesion }}
                              </p>
                              <p style="margin: 4%">
                                <label>OD:</label>{{ item.numeroDiente }}
                              </p>
                            </div>
                          </div>
                          <div></div>
                        </b-card>
                      </div>
                    </vue-custom-scrollbar>
                  </div>
                  <div v-else>
                    <b-card
                      style="
                        padding: 2%;
                        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
                      "
                    >
                      <div class="row">
                        <div class="col-3">
                          <img
                            width="50px"
                            style="max-width: 100%"
                            src="../../../assets/icons/tratamiento.png"
                          />
                        </div>
                        <div class="col-9" style="text-align: left">
                          <p style="margin: 4%">
                            No se encontraron tratamientos
                          </p>
                        </div>
                      </div>
                    </b-card>
                  </div>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <p
                    style="
                      text-align: left;
                      color: #093974;
                      font-size: 18px;
                      font-weight: 600;
                    "
                  >
                    Tratamientos por realizar
                  </p>
                  <div
                    v-if="datosAdicionales.tratamientosPorRealizar.length > 0"
                  >
                    <vue-custom-scrollbar
                      class="scroll-area"
                      :settings="settings"
                      @ps-scroll-y="scrollHanle"
                    >
                      <b-card
                        v-for="item in datosAdicionales.tratamientosPorRealizar"
                        :key="'tx' + item.idTratamientoProgramado"
                        style="
                          padding: 2%;
                          box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
                        "
                      >
                        <div class="row">
                          <div class="col-3">
                            <img
                              width="100%"
                              style="max-width: 100%"
                              src="../../../assets/icons/tratamiento.png"
                            />
                          </div>
                          <div class="col-9" style="text-align: left">
                            <p style="margin: 4%">
                              <label>Tx:</label>{{ item.tratamiento }}
                            </p>
                          </div>
                        </div>
                      </b-card>
                    </vue-custom-scrollbar>
                  </div>
                  <div v-else>
                    <b-card
                      style="
                        padding: 2%;
                        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
                      "
                    >
                      <div class="row">
                        <div class="col-3">
                          <img
                            width="50px"
                            style="max-width: 100%"
                            src="../../../assets/icons/tratamiento.png"
                          />
                        </div>
                        <div class="col-9" style="text-align: left">
                          <p style="margin: 4%">
                            No se encontraron tratamientos
                          </p>
                        </div>
                      </div>
                    </b-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid main-component" style="margin-bottom: 3%">
        <p
          style="
            text-align: left;
            color: #093974;
            font-size: 18px;
            font-weight: 600;
            margin-top: 3%;
          "
        >
          Información
        </p>
        <div class="row justify-content-center">
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <b-form-group align="left">
              <label>Antigüedad del Px atendiéndose en Dentalia</label>
              <b-form-input
                @keypress="onlyNumber"
                v-model="$v.dictamen.antiguedad.$model"
                :state="validateState('antiguedad')"
              >
                >
              </b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <b-form-group align="left">
              <label>Familiares o referidos atendiéndose en Dentalia</label>
              <v-select
                :options="select"
                label="text"
                :reduce="(fin) => fin.value"
                v-model="$v.dictamen.familiares.$model"
                :state="validateState('familiares')"
              >
                >
              </v-select>
            </b-form-group>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
            <b-form-group align="left">
              <label>Constancia de su atención (repetitivo)</label>
              <v-select
                :options="select"
                label="text"
                :reduce="(fin) => fin.value"
                v-model="$v.dictamen.recurrente.$model"
                :state="validateState('recurrente')"
              >
                >
              </v-select>
            </b-form-group>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <b-form-group align="left">
              <label>Historia de servicio del paciente</label>
              <b-form-textarea
                v-model="$v.dictamen.historia.$model"
                :state="validateState('historia')"
              >
                >
              </b-form-textarea>
            </b-form-group>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <b-form-group align="left">
              <label>¿Es imputable al doctor?</label>
              <v-select
                :options="select"
                label="text"
                :reduce="(fin) => fin.value"
                v-model="$v.dictamen.imputableDoctor.$model"
                :state="validateState('imputableDoctor')"
              >
                >
              </v-select>
            </b-form-group>
          </div>

          <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
            <b-form-group align="left">
              <label>Sugerencia CC, ¿entra en garantía?</label>
              <v-select
                :options="select"
                label="text"
                :reduce="(fin) => fin.value"
                v-model="$v.dictamen.esGarantiaCC.$model"
                @input="reiniciarTratamientos()"
                :state="validateState('esGarantiaCC')"
              >
                >
              </v-select>
            </b-form-group>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12">
            <b-form-group align="left">
              <label>Comentarios de mejora de la clínica</label>
              <b-form-textarea
                v-model="$v.dictamen.descripcionGarantiaCC.$model"
                :state="validateState('descripcionGarantiaCC')"
              >
                >
              </b-form-textarea>
            </b-form-group>
          </div>
        </div>
        <div v-if="dictamen.esGarantiaCC">
          <b-row class="divSubtitulo mb-3">
            <b-col>
              <p class="textSubtitulo">Tratamientos a garantia</p>
            </b-col>
            <b-col class="text-right m-auto">
              <font-awesome-icon
                v-b-tooltip.hover
                title="Agregar garantia"
                class="editar"
                style="font-size: large"
                icon="plus-circle"
                @click="agregarGarantia()"
              />
            </b-col>
          </b-row>
          <b-row
            v-for="(tx, i) in dictamen.tratamientosGarantia"
            :key="'tratamiento' + i"
            class="text-left"
          >
            <b-col>
              <label>Tratamiento realizado:</label>
              <v-select
                :reduce="(tx) => tx.idSesionTratamientoProgramado"
                :options="tratamientoRelizados"
                label="tratamiento"
                v-model="tx.idSesionTratamientoProgramado"
              ></v-select>
            </b-col>
            <b-col cols="1">
              <label>OD:</label>

              <b-form-select block v-model="tx.idDiente">
                <b-form-select-option
                  v-for="diente in arrayDiente"
                  :value="diente.idDiente"
                  :key="diente.idDiente"
                >
                  <p v-if="diente.numeroDiente == 0">
                    {{ diente.numeroDiente }}-{{ diente.nombre }}
                  </p>
                  <p v-else>{{ diente.numeroDiente }}</p>
                </b-form-select-option>
              </b-form-select>
            </b-col>
            <b-col>
              <label>Tratamiento a resolver:</label>
              <v-select
                v-model="tx.idTratamiento"
                :options="tratamientos"
                label="nombre"
                :reduce="(fin) => fin.idTratamiento"
              ></v-select>
            </b-col>
            <b-col class="text-center m-auto" cols="1">
              <div>
                <font-awesome-icon
                  v-b-tooltip.hover
                  title="Eliminar garantia"
                  class="eliminar"
                  icon="times-circle"
                  @click="eliminarGarantia(tx)"
                />
              </div>
            </b-col>
          </b-row>
        </div>

        <div style="margin-top: 3%">
          <b-button
            variant="outline-primary"
            :disabled="loaderGuardar"
            @click="guardar()"
          >
            <span v-if="!loaderGuardar">Guardar</span>
            <span v-if="loaderGuardar">
              <b-spinner small></b-spinner>
              Cargando...
            </span>
          </b-button>
        </div>
      </div>
      <b-modal
        v-model="modalComentarios"
        title="Comentarios del paciente"
        scrollable
        size="lg"
      >
        <p style="font-size: 18px; font-weight: 600">El paciente comenta:</p>
        <div class="container-fluid main-component p-3 text-justify">
          <p>{{ datos.comentarios }}</p>
        </div>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Header from "../../../components/Header";
import { GarantiaService } from "../../../apiServices/garantias/GarantiaService";
import { CatalogosService } from "../../../apiServices/catalogos/CatalogosService";
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";

export default {
  name: "dicatamenOperativo",
  components: { Header, vueCustomScrollbar },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false,
      },
      garantiaServicio: new GarantiaService(),
      catalogoServicio: new CatalogosService(),
      select: [
        { value: true, text: "Si" },
        { value: false, text: "No" },
      ],
      modalComentarios: false,
      idTicket: null,
      idEtapa: null,
      tipos: [],
      loaderGuardar: false,
      datos: {
        origen: "",
        comentarios: "",
        idPaciente: "",
        paciente: "",
        driver: "",
        tema: "",
        subtema: "",
      },

      datosAdicionales: null,

      dictamen: {
        idDictamnOperaciones: null,
        idTipoPaciente: null,
        idSolicitud: null,
        idTipoPanciente: null,
        antiguedad: null,
        familiares: null,
        recurrente: null,
        historia: null,
        montoPti: null,
        imputableDoctor: null,
        esGarantiaCC: null,
        descripcionGarantiaCC: null,
        tratamientosGarantia: [],
      },
      tratamientoRelizados: [],
      tratamientos: [],
      dientes: [],
      sesiones: [],
      fechaNacPaciente: null,
      arrayDiente: [],
    };
  },
  validations: {
    dictamen: {
      antiguedad: { required },
      familiares: { required },
      recurrente: { required },
      historia: { required },
      imputableDoctor: { required },
      esGarantiaCC: { required },
      descripcionGarantiaCC: { required },
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idTicket = this.$route.params.id;
    this.idEtapa = this.$route.params.idEtapa;
    this.obtenerTipoPaciente();
    this.obtenerInformacionTicket();
    this.obtenerTratamientos();
    this.obtenerDientes();
  },
  methods: {
    getCatalogoDientes() {
      const hoy = this.$moment(new Date());
      const nac = this.$moment(new Date(this.fechaNacPaciente));
      var anios = hoy - nac;
  
      var tipoDiente = 0;
      if (anios <= 6) {
        tipoDiente = 1;
      } else if (anios >= 7 && anios <= 12) {
        tipoDiente = 2;
      } else if (anios > 12) {
        tipoDiente = 3;
      }

      this.arrayDiente = [];
      var url = "";
      if (tipoDiente === "2") {
        url = "catalogos/listaDientesAdulto/concero";
      } else if (tipoDiente === "1") {
        url = "catalogos/listaDientesInfantil/concero";
      } else if (tipoDiente === "3") {
        url = "catalogos/listaDientes/ordenados/concero";
      } else {
        tipoDiente = "3";
        url = "catalogos/listaDientes/ordenados/concero";
      }

      this.$http
        .get(this.$api + url)
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            this.arrayDiente = response.data.data;
          }
        })
        .catch((error) => {
          console.error("Catalogo de Dientes: " + error);
        });
    },
    obtenerSesiones() {
      const parametros = {idPaciente: this.datos.idPaciente}
      this.$http
        .post(
          this.$api +
            "tratamiento_sesion/obtenerSesionesRealizadas", parametros
        )
        .then((response) => {
          if (response.data.data) {
            this.sesiones = response.data.data;
          }
        })
        .catch(function (error) {
          console.error(error);
          this.loaderTratamientossesion = false;
        });
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },

    obtenerTratamientos() {
      this.catalogoServicio
        .obtenerTratamientosConEspecilidades()
        .then((response) => {
          this.tratamientos = response;
        });
    },
    obtenerDientes() {
      this.catalogoServicio.obtenerDientes().then((response) => {
        this.dientes = response.data;
      });
    },

    async obtenerInformacionTicket() {
      const parametros = {idTicket: this.idTicket}
      this.garantiaServicio.obtenerTicket(parametros).then((respuesta) => {
        this.datos = respuesta.data;
        this.obtenerDatosAdicionales();
        this.obtenerDatosPacienteYTratamientosRealizados();
        this.obtenerSesiones();
      });
    },
    obtenerDatosPacienteYTratamientosRealizados() {
      let body = {
        "idPaciente":this.datos.idPaciente
      }
      this.garantiaServicio
        .obtenerDatosPacienteYTratamientosRealizados(body)
        .then((respuesta) => {
          this.tratamientoRelizados = respuesta.data.tratamientos;
          this.fechaNacPaciente = respuesta.data.fecha;
          this.getCatalogoDientes();
        });
    },
    obtenerDatosAdicionales() {
      const parametros = {idPaciente: this.datos.idPaciente}
      this.garantiaServicio
        .obtenerDatosAdicionales(parametros)
        .then((respuesta) => {
          this.datosAdicionales = respuesta.data;
        });
    },
    obtenerTipoPaciente() {
      this.catalogoServicio.tipoPaciente().then((res) => {
        this.tipos = res.data;
      });
    },
    guardar() {
      this.$v.dictamen.$touch();
      if (this.$v.dictamen.$anyError) {
        return false;
      }

      if (this.validarGarantia()) {
        this.$swal.fire({
          icon: "info",
          title: "Advertencia",
          text: "Registros de garantias sin datos",
        });
        return false;
      }

      this.loaderGuardar = true;
      const envio = JSON.parse(JSON.stringify(this.dictamen));
      envio.idSolicitud = this.idTicket;
      envio.idTipoPaciente = this.datosAdicionales.idTipoPaciente;
      envio.montoPti = this.datosAdicionales.montoPti;

      this.garantiaServicio
        .guardarDictamen(envio, this.idEtapa)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Se registro correctamente",
            showConfirmButton: false,
          });
          this.$v.$reset();
          window.history.back();
        })
        .finally(() => {
          this.loaderGuardar = false;
        });
    },
    validarGarantia() {
      if (this.dictamen.esGarantiaCC) {
        const datos = this.dictamen.tratamientosGarantia.filter((t) => {
          return (
            t.idSesionTratamientoProgramado === null ||
            t.idDiente === null ||
            t.idTratamiento === null
          );
        });
        if (datos.length > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.dictamen[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute);
      if (state) {
        return "border rounded-lg border-success";
      } else if (state === false) {
        return "border rounded-lg border-danger";
      } else {
        return "";
      }
    },

    agregarGarantia() {
      this.dictamen.tratamientosGarantia.push({
        idSesionTratamientoProgramado: null,
        idDiente: null,
        idTratamiento: null,
      });
    },
    eliminarGarantia(item) {
      this.dictamen.tratamientosGarantia.splice(
        this.dictamen.tratamientosGarantia.indexOf(item),
        1
      );
    },
    reiniciarTratamientos() {
      if (this.dictamen.esGarantiaCC) {
        this.agregarGarantia();
      } else {
        this.dictamen.tratamientosGarantia = [];
      }
    },
  },
};
</script>

<style scoped>
.bCardGlobal {
  margin: 2% 4% 2% 4%;
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.divSubtitulo {
  width: 100%;
  margin-top: 2%;
  border-bottom: 5px solid #8ec6e9;
}

.divInput {
  margin-left: 1%;
  margin-right: 3%;
}

.textSubtitulo {
  color: #093974;
  font-weight: 600;
  font-size: 22px;
  text-align: left;
}

.overflow-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scroll-area {
  position: relative;
  margin: auto;
  height: 500px;
}
</style>
